module.exports = __webpack_public_path__ + "img/mobile-catch-plan.45608be8.svg";